import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {connect} from 'react-redux';
// components
import '../assets/stylesheet/page404.css';

function Page404(props) {
    const navigate = useNavigate();

    useEffect(() => {

        document.querySelector('.cont_principal').className= "cont_principal cont_error_active";  
        const disableBackButton = (e) => {
            e.preventDefault();
            navigate('/');
            // return false;
        };

        // Disable the back button
        // window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', disableBackButton);

        return () => {
        // Remove the event listener when the component unmounts
        window.removeEventListener('popstate', disableBackButton);
        };
    }, []);

    const goTo = () => {
        const { company } = props;
        const companyId = company ? company?.urlName || company?.id : ''; 
        const host = window.location?.host;
        const list = ['my.selynk.com', 'localhost:3001','localhost:3002'];
        const origin = host === 'user.selynk.com' ? 'https://user.selynk.com/' : list?.includes(host) ? `https://${host}/${companyId}` : window?.location?.origin;
        window.location.href=origin;
    }

    return(
        <div className='page404'>
        <div className="cont_principal">
            <div className="cont_error">
                <h1>Oops</h1>  
                <p>It looks like you are lost..</p>
                <button className='btn third' onClick={goTo}>GO Back to Home</button>
            </div>
            <div className="cont_aura_1"></div>
            <div className="cont_aura_2"></div>
        </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        user: state.user,
        company: state.company
    }
}

export default connect(mapStateToProps,null)(Page404);